import { createSelector } from '@reduxjs/toolkit';

import { calendarEventsKey, CalendarEventsState } from './calendar-events.actions';

export const selectEventsCards = createSelector(
    (state: { [calendarEventsKey]: CalendarEventsState }) => state[calendarEventsKey],
    (state: CalendarEventsState) => state.eventCards,
);

export const selectEventCardsSortedByScore = createSelector(
    (state: { [calendarEventsKey]: CalendarEventsState }) => state[calendarEventsKey],
    (state: CalendarEventsState) => [...state.eventCards].sort((a, b) => b.score - a.score), // Make a copy before sorting
);

export const selectEventCardsSortedByDate = createSelector(
    (state: { [calendarEventsKey]: CalendarEventsState }) => state[calendarEventsKey],
    (state: CalendarEventsState) => [...state.eventCards].sort((a, b) => a.dateInt - b.dateInt), // Make a copy before sorting
);

export const selectEventsLoading = createSelector(
    (state: { [calendarEventsKey]: CalendarEventsState }) => state[calendarEventsKey],
    (state: CalendarEventsState) => state.eventsLoading,
);

export const selectEventsSearchIds = createSelector(
    (state: { [calendarEventsKey]: CalendarEventsState }) => state[calendarEventsKey],
    (state: CalendarEventsState) => state.eventCardSearchedIds,
);
